module.exports = __webpack_public_path__ + "img/1.7ca86346.jpg";